import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { ProcessorJobStatus } from './processor-job';
export const pipelineDashboardItemSchema = z
    .object({
    id: z.string().uuid(),
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    job_type: z.string(),
    pipeline_name: z.string(),
    status: z.nativeEnum(ProcessorJobStatus),
    created_at: z.string(),
    updated_at: z.string(),
    current_stage: z.string().nullable(),
    total_stages: z.number().int(),
    completed_stages: z.number().int(),
    total_tasks: z.number().int(),
    completed_tasks: z.number().int(),
    failed_tasks: z.number().int(),
    package_name: z.string().nullable(),
    service_type: z.string().nullable(),
    published: z.boolean().nullable(),
})
    .transform(mapToCamelCase);
export const getPipelineDashboardResponseSchema = z
    .object({
    count: z.number().int(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.array(pipelineDashboardItemSchema),
})
    .transform(mapToCamelCase);
